import { HttpResponse } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { FilterSearchingTVariedadViewModel, TVariedadViewModel, TwTcVariedadCamViewModel, VariedadItemResultsViewModel } from './variedad.types';

@Injectable()
export class VariedadService {
    variedadEndpoint = this.baseUrl + 'api/mantenimiento/variedad/';
    arrBooleanKeys = ['Activo', 'HabilitadaImportacion', 'HabilitadaExportacion', 'HabilitadaChina'];
    private lastSearch?: FilterSearchingTVariedadViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingTVariedadViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingTVariedadViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingTVariedadViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNoTodos.NO) {
                v = 0;
            } else {
                v = payload[k] || '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    /**
     * Invokes the service to get the list of "Variedades", applying the filter in the parameter
     * @param payload FilterSearchingTVariedadViewModel
     * @returns Observable<VariedadItemResultsViewModel>
     */
    getVariedades(payload: FilterSearchingTVariedadViewModel): Observable<VariedadItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getVariedadesPagedByFilter(params);
    }

    /**
     * Invokes the service to get the list of "Variedades", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<VariedadItemResultsViewModel>
     */
    private getVariedadesPagedByFilter(params: HttpParams): Observable<VariedadItemResultsViewModel> {
        return this.http.get<VariedadItemResultsViewModel>(this.variedadEndpoint + 'PagedByFilter/', { params: params });
    }

    getVariedad(id: number): Observable<TVariedadViewModel> {
        return this.http.get<TVariedadViewModel>(this.variedadEndpoint + id);
    }

    saveVariedad(variedad: TVariedadViewModel): Observable<any> {
        // delete model.Descripcion;  // Para forzar un fallo en el backend y ver que pasa en el catchError
        if (variedad?.Id) {
            return this.editVariedad(variedad);
        }
        return this.createVariedad(variedad);
    }

    private createVariedad(variedad: TVariedadViewModel): Observable<any> {
        // variedad.Id = 1121; // Para forzar un fallo en el backend y ver que pasa en el catchError
        return this.http.post<TVariedadViewModel>(this.variedadEndpoint, variedad);
    }

    private editVariedad(variedad: TVariedadViewModel): Observable<any> {
        // variedad.Id = null; // Para forzar un fallo en el backend y ver que pasa en el catchError
        return this.http.put<TVariedadViewModel>(this.variedadEndpoint, variedad);
    }

    export(model: FilterSearchingTVariedadViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.variedadEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingTVariedadViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    getAllVariedades(): Observable<TwTcVariedadCamViewModel[]> {
        return this.http.get<TwTcVariedadCamViewModel[]>(this.variedadEndpoint + 'AllVariedades');
    }

    getVariedadesByPeriodo(idPeriodoCam: number): Observable<VariedadItemResultsViewModel> {
        return this.http.get<VariedadItemResultsViewModel>(this.variedadEndpoint + 'ByPeriodoCam/' + idPeriodoCam);
    }
}
